import { Edit, RadioButtonGroupInput, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { RichTextInput } from 'ra-input-rich-text';
import { categoryChoices } from './const';

export const PageEdit = (_props: unknown) => (
  <Edit title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <RadioButtonGroupInput source="category" choices={categoryChoices} />
      <TextInput source="title" />
      <RichTextInput source="body" />
    </SimpleForm>
  </Edit>
);
